
export const options = [
    {
        title: 'Discover',
        path: '/public/client/discover'
    },
    {
        title: 'Store',
        path: '/public/client/store'
    },
]